import React from "react";
import styled from "styled-components";
import { breakpoints, color } from "style/constants";
import { Tab, Tabs } from "@material-ui/core";

export const IconWrapper = styled.div`
  .MuiTabs-flexContainer {
    width: 150px;
    justify-content: flex-end;
    align-items: center;
    .MuiIconButton-root:hover {
      background-color: transparent;
    }
    * {
      min-width: 30px;
      max-width: 30px;
    }
    * + * {
      margin-left: 30px;
    }
    * > span {
      background-color: ${color.ICON};
      border-radius: 100%;
      height: 30px;
      width: 30px;
    }
  }
  svg {
    height: 15px;
    width: 15px;
    path {
      stroke: ${color.BLACK};
      stroke-width: 2px;
    }
  }
`;

export const StyledTab = styled(({ ...otherProps }) => <Tab {...otherProps} />)`
  && {
    font-size: 1rem;
    text-transform: none;
  }
`;

export const StyledTabs = styled(({ ...otherProps }) => <Tabs {...otherProps} />)`
  .MuiTab-fullWidth {
    flex-basis: auto;
  }
`;
